module.exports = __webpack_public_path__ + "img/plus-icon-white.67840856.svg";